import Helper from '@ember/component/helper';
import { v4 as Uuid } from 'ember-uuid';

const keyedTimeoutIds: Record<string, ReturnType<typeof setTimeout>> = {};

export default class DebounceHelper extends Helper {
  compute(
    positional: [() => void],
    namedArgs?: { key?: boolean; wait?: number },
  ) {
    const [callback] = positional;
    const key = namedArgs?.key || Uuid();
    const wait = namedArgs?.wait ?? 500;

    return function <T, A extends []>(this: { this: T }, ...args: A) {
      const self = this;

      const timeoutId = keyedTimeoutIds[key];
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      keyedTimeoutIds[key] = setTimeout(() => {
        callback.apply(self, args);
        delete keyedTimeoutIds[key];
      }, wait);
    };
  }
}
